import { translation as admin } from './admin.js';
import { translation as common } from './common.js';
import { translation as components } from './components.js';
import { translation as customProperties } from './customProperties.js';
import { translation as dbt } from './dbt.js';
import { translation as deploymentHistory } from './deploymentHistory.js';
import { translation as deploymentOverview } from './deploymentOverview.js';
import { translation as deployTransformation } from './deployTransformation.js';
import { translation as errorFallbacks } from './errorFallbacks.js';
import { translation as errors } from './errors.js';
import { translation as executionHistory } from './executionHistory.js';
import { translation as forms } from './forms.js';
import { translation as formulaEditor } from './formulaEditor.js';
import { translation as glossary } from './glossary.js';
import { translation as healthcheck } from './healthcheck.js';
import { translation as inventory } from './inventory.js';
import { translation as jobs } from './jobs.js';
import { translation as migration } from './migration.js';
import { translation as notifications } from './notifications.js';
import { translation as queries } from './queries.js';
import { translation as slack } from './slack.js';
import { translation as summarize } from './summarize.js';
import { translation as usage } from './usage.js';
import { translation as workbench } from './workbench.js';

export const resources = {
    admin,
    common,
    components,
    customProperties,
    dbt,
    deploymentHistory,
    deploymentOverview,
    deployTransformation,
    errorFallbacks,
    errors,
    executionHistory,
    forms,
    formulaEditor,
    glossary,
    healthcheck,
    inventory,
    jobs,
    migration,
    notifications,
    queries,
    slack,
    summarize,
    usage,
    workbench
};
